import { Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

import { PortalHeaderComponent } from '../header/portal-header.component';
import { SidebarMenuComponent } from '../sidebar/sidebar-menu.component';

@Component({
  selector: 'app-portal-layout',
  standalone: true,
  imports: [PortalHeaderComponent, RouterOutlet, SidebarMenuComponent],
  templateUrl: './portal-layout.component.html',
  styleUrls: ['./portal-layout.component.scss']
})
export class PortalLayoutComponent {
  private readonly router = inject(Router);
  private readonly currentUrl = signal(this.router.url);

  constructor() {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentUrl.set(event.urlAfterRedirects);
    });
  }

  readonly isFullBleedPage = computed(() => this.currentUrl() === '/master/menus');
  readonly sidebarCollapsed = signal(true);
}
